import(/* webpackMode: "eager" */ "/codebuild/output/src1690843238/src/helloero-new/packages/account/src/app/error.tsx");
